<template>
  <div class="text-center">
    <h2>Les lieux de rencontre</h2>
    <b-row>
      <b-col class="text-center" v-for="location in locations" :key="location.id">
        <Location :location="location" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from 'vue'
import Location from '@/components/parts/Location'

export default {
  name: 'Maps',
  data: function(){
    return {
      locations: [],
    }
  },
  created: function(){
    Vue.$backend.getLocations().then(res => this.locations = res)
  },
  components: {
    Location,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
